import React, { useEffect } from 'react';
import { Modal, Form, Input } from 'antd';

const FlowDetailsModalOnFlowScreen = ({ visible, onClose, formData, onSave }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        name: formData?.label ? formData?.label : formData?.name || '',
        apiName: formData?.apiName ? formData?.apiName : formData?.name || formData?.name,
        description: formData?.description || '',
      });
    }
  }, [visible, formData, form]);

  // Converts "My Flow Name" -> "my_flow_name"
  const generateApiName = (value) => {
    return value
      .trim()
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
      .replace(/\s+/g, "") // Remove spaces
                      
  };

  const handleNameBlur = () => {
    const nameValue = form.getFieldValue('name');
    const apiNameValue = form.getFieldValue('apiName');

    // Only auto-generate if apiName is still empty
    if (nameValue) {
      const generated = generateApiName(nameValue);
      form.setFieldsValue({ apiName: generated });
    }
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(values => {
        onSave(values);
        onClose();
      })
      .catch(info => {
        console.log('Validation Failed:', info);
      });
  };

  return (
    <Modal
      title="Flow Details"
      visible={visible}
      onCancel={onClose}
      onOk={handleOk}
      zIndex={1002}   // higher than sidebar
      okText="Save"
    >
      <Form form={form} layout="vertical" name="flowDetailsForm">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please input the Name!' }]}
        >
          <Input onBlur={handleNameBlur} />
        </Form.Item>

        <Form.Item
          label="API Name"
          name="apiName"
          rules={[{ required: true, message: 'Please input the API Name!' }]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
        >
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FlowDetailsModalOnFlowScreen;
